import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 240px;
  border-right: 1px solid var(--system-gray-2);

  > a {
    margin: 40px 0 40px 32px;
    display: block;
    width: max-content;
  }

  @media (max-width: 767px) {
    /* display: none; */
    padding: 40px 0px;
    height: 100vh;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: scroll;
    background: var(--system-white);
    box-shadow: 0px 2px 10px rgba(5, 36, 66, 0.15);
    z-index: 10000;
    width: 240px;
    transition: all cubic-bezier(0.15, 0.82, 1, 1) 0.6s;
    transform: ${({ expanded }) => !expanded && 'translateX(45%)'};
    opacity: ${({ expanded }) => !expanded && '0'};
    max-width: ${({ expanded }) => (expanded ? '100vw' : '0px')};

    > * {
      opacity: ${({ expanded }) => !expanded && '0'};
      transition: all cubic-bezier(0.15, 0.82, 1, 1) 0.3s;
    }

    > a {
      display: none;
    }
  }
`;
